import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { LibyaMap } from "@/components/LibyaMap";
import { Reveal } from "@/components/Motion";

export const MapPanel = ({ showLinks = true }) => {
  const { t, lp } = useLang();
  const [active, setActive] = useState("julyana");
  return (
    <div className="grid items-stretch gap-px border border-[#8EA3BC]/40 bg-[#8EA3BC]/40 lg:grid-cols-12" data-testid="map-panel">
      <div className="bg-[#F7F9FB] p-4 sm:p-8 lg:col-span-7">
        <LibyaMap active={active} onSelect={setActive} className="h-auto w-full" />
      </div>
      <div className="grid gap-px bg-[#8EA3BC]/40 lg:col-span-5">
        {["julyana", "sirte"].map((k, i) => {
          const z = t.locationsShort[k];
          const on = active === k;
          return (
            <Reveal key={k} delay={i * 0.1} className={`relative bg-white p-8 transition-colors duration-500 ${on ? "bg-white" : ""}`}>
              <div onMouseEnter={() => setActive(k)} data-testid={`location-card-${k}`}>
                <span className={`absolute inset-y-0 start-0 w-1 transition-colors duration-500 ${on ? "bg-[#C59B27]" : "bg-transparent"}`} aria-hidden="true" />
                <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#4A5D75]"><MapPin className="h-4 w-4 text-[#A27D17]" aria-hidden="true" />{z.city}</p>
                <h3 className="mt-3 font-serif text-2xl text-[#1E3A5F] sm:text-3xl">{z.name}</h3>
                <p className="mt-3 leading-relaxed text-[#4A5D75]">{z.d}</p>
                {showLinks && (
                  <Link to={lp(`/locations#${k}`)} className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#1E3A5F] link-underline" data-testid={`location-link-${k}`}>
                    {t.common.viewLocation}<ArrowUpRight className="h-4 w-4 rtl:-scale-x-100" />
                  </Link>
                )}
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
};
